<!--
 * @Author: gaoxueting
 * @Date: 2020-06-03 16:32:21
 * @LastEditTime: 2020-08-10 18:20:04
 * @LastEditors: fengzhongmei
 * @Description:
 * @FilePath: /rightcloud-console2/src/views/components/biz/subnet/related.vue
-->
<template>
    <Modal v-model="modal"
           :width="700"
           :title="$t('关联子网')"
           class="clsubnet"
           :mask-closable="false"
           @on-cancel="cancel">
        <rcTable ref="tablerelation"
                 v-if="modal"
                 @onSelectChange="updateSelected"
                 :tableAttr="tableAttr">
        </rcTable>
        <div slot="footer">
            <Button type="text"
                    @click="cancel">{{$t('取消')}}</Button>
            <Button type="primary"
                    :loading="loading"
                    :disabled="selected.length === 0"
                    @click="submit">{{loading ? $t('保存中'):$t('保存')}}</Button>
        </div>
    </Modal>
</template>

<script>
import rcTable from '@c/basic/rcTable'
import API from '@/service/api.js'
export default {
    name: 'clsubnet',
    props: ['type'],
    components: {
        rcTable
    },
    data () {
        return {
            modal: false,
            loading: false,
            selected: [],
            tableAttr: {
                source: {
                    type: 'get',
                    url: this.urlFormat(API.GET_ACL_UNBIND_SUBNET, false),
                    params: {
                        cloudEnvId: this.envId,
                        fireWallId: this.id
                    }
                },
                searchColumns: [
                    {
                        key: 'networkNameLike',
                        title: this.$t('子网'),
                        searchDefaultValue: ''
                    },
                    {
                        key: 'cidr',
                        title: this.$t('网段'),
                        searchDefaultValue: ''
                    },
                    {
                        key: 'vpcName',
                        title: this.$t('网络'),
                        searchDefaultValue: ''
                    }
                ],
                searchShow: true,
                isMultiSelect: true,
                columnsChooseShow: true,
                columns: [
                    {
                        title: this.$t('子网'),
                        key: 'networkName',
                        className: 'ellipsis',
                        disabledSearch: true,
                        columnShow: true,
                        columnsChoosed: true,
                        render: (h, params) => {
                            return h('span', { attrs: { title: params.row.networkName } }, params.row.networkName)
                        }
                    },
                    {
                        title: this.$t('网段'),
                        key: 'cidr',
                        className: 'ellipsis',
                        disabledSearch: true,
                        columnShow: true,
                        columnsChoosed: true
                    },
                    {
                        title: this.$t('私有网络'),
                        key: 'vpcName',
                        className: 'ellipsis',
                        disabledSearch: true,
                        columnShow: true,
                        columnsChoosed: true
                    }
                ]
            },
            row: {}
        }
    },
    watch: {
    },
    methods: {
        // 打开弹出框
        openModal (row) {
            this.envId = row.cloudEnvId
            this.id = row.id
            // this.row = row
            if (this.type === 'acl') {
                this.tableAttr.source.url = this.urlFormat(API.GET_ACL_UNBIND_SUBNET, false)
                this.tableAttr.source.params = {
                    cloudEnvId: row.cloudEnvId,
                    fireWallId: row.id
                }
            }
            this.modal = true
        },
        // 勾选
        updateSelected (selection) {
            this.selected = selection
        },
        // 取消
        cancel () {
            this.modal = false
        },
        // 保存
        submit () {
            if (this.selected.length === 0) {
                this.$Message.error(this.$t('请至少选择一项'))
            } else {
                this.loading = true
                const ids = []
                this.selected.forEach(item => {
                    ids.push(item.id)
                })
                const params = {
                    cloudEnvId: this.envId,
                    id: this.id,
                    subnetIds: ids.join(',')
                }
                this.axios.post(this.urlFormat(API.GET_ACL_ATTACH_SUBNET, false), params).then(res => {
                    this.$emit('refresh')
                    this.cancel()
                    this.loading = false
                }).catch(e => {
                    this.loading = false
                })
            }
        },
        refresh () {
            this.$refs.tablerelation.refreshTable({
                cloudEnvId: this.envId,
                fireWallId: this.id
            })
            this.selected = []
        }
    }
}
</script>

<style lang="less" scoped>
</style>
